export enum KnowledgeCardsIntentType {
	PERSON = 'PERSON',
	TEAM = 'TEAM',
	AGENT = 'AGENT',
	VISUAL = 'VISUAL',
}
